import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Select from 'react-select'; //04-03-2024-multiselect




export default function CourseDisciplineAECMapping() {

  const [message, setMessage] = useState(false);
  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [course_component, setCourse_component] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(false);
  const [facultyname, setFacultyname] = useState(false);
  const { http } = Api();
  const [errors, setErrors] = useState({ cfaculty: '', cdiscipline: '', csemester: '', ccomponenttype: '', ccourse: '' });



  const navigate = useNavigate();

  useEffect(() => {

    fetchData();

  }, []);

  const fetchData = async () => {
    try {
      const { http } = Api();

      const response4 = await http.get('/Admin/getfaculty');
      setFacultyData(response4.data.data);
      const response1 = await http.get(`/Admin/getdiscipline`);
      setDisciplineData(response1.data.data);


    } catch (error) {

      console.error('Error fetching Course data:', error);
    }
  };

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }


  const cancelForm = () => {
    navigate("/admin/coursedisciplineAECmapping");
  };

  const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;


    const faculty_id = document.getElementById('faculty_id').value;
    const discipline_id = document.getElementById('discipline_id').value;
    const semester_id = document.getElementById('semester_id').value;
    const coursecomponentstype = document.getElementById('coursecomponentstype').value;
    const course = document.getElementById('coursecomponent').value;

    if (faculty_id === "0") {
      updatedErrors.cfaculty = 'select  a faculty';
      hasError = true;
    }

    if (discipline_id === "0") {

      updatedErrors.cdiscipline = 'select a discipline';
      hasError = true;
    }
    if (semester_id === "0") {
      updatedErrors.csemester = 'select a semester';
      hasError = true;
    }


    if (coursecomponentstype == "") {

      updatedErrors.ccomponenttype = 'Select a Course Component Type';
      hasError = true;
    }

    if (selectedCourse === false) {

      updatedErrors.ccourse = 'select a course';
      hasError = true;
    }


    if (hasError) {
      setErrors(updatedErrors);
      return false;

    } else {
      setErrors({ cfaculty: '', cdiscipline: '', csemester: '', ccomponenttype: '', ccourse: '' });
      return true;
    }

  };

  const saveForm = async () => {
    if (validateForm()) {
      const faculty_id = document.getElementById('faculty_id').value;
      const discipline_id = document.getElementById('discipline_id').value;
      const semester_id = document.getElementById('semester_id').value;
      const coursecomponentstype = document.getElementById('coursecomponentstype').value;
      const remarks = document.getElementById('remarks').value;
      const remarksValue = remarks ? remarks : "Null";
  
      try {
        const response = await http.post(`Admin/savecoursemapping`, {
          faculty_id: faculty_id,
          discipline_id: discipline_id,
          semester_id: semester_id,
          course_curriculum_structure_component_id: coursecomponentstype,
          course_id: selectedCourse,
          remarks: remarksValue,
          status: "active"
        });
         console.log(response);
        if (response.data.status_code === "MSG1") {
          sessionStorage.setItem("message", "New Aec Mapping Added Successfully");
          navigate("/admin/coursedisciplineAECmapping");
          console.log(response);
        }
      } catch (error) {
        console.error(error);
        if (error.response && error.response.data.status_code === "ERR2") {
          setMessage("Please fill all outcomes");
        } else if (error.response && error.response.data.status_code === "ERR1") {
          setMessage("Duplicate entry");
        } else {
          setMessage("Something Went Wrong");
        }
      }
    }
  };

  //used to get dicipline based on faculty
  const isdisiplin = () => {
    const faculty_id = document.getElementById('faculty_id').value;
    const selectedFaculty = faculty.find(facultys => parseInt(facultys.id) === parseInt(faculty_id));
    setFacultyname(selectedFaculty.faculty_name);
    fetchCourseComponents();
  }

  const ischange = () => {
    fetchCourseComponents();
  }

  const fetchCourseComponents = async () => {
    try {
      const faculty_id = document.getElementById('faculty_id').value;
      const discipline_id = document.getElementById('discipline_id').value;
      const semester_id = document.getElementById('semester_id').value;
      const coursecomponentstype = document.getElementById('coursecomponentstype').value;

      const response = await http.get(`Admin/getCourseMappingByFacDisSemComp/{faculty_id}/{discipline_id}/{semester_id}/{component_id}?{params}`, {
        params: {
          faculty_id,
          discipline_id,
          semester_id,
          course_curriculum_structure_component_id: coursecomponentstype
        }
      });
      console.log(response);
      setCourse_component(response.data);
    } catch (error) {
      console.error('Error fetching Course component data:', error);
    }
  };

  const handleCourseComponentChange = (selectedOption) => {

    setSelectedCourse(selectedOption.value);
  }
  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Course Discipline AEC Mapping</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {message && (
                      <div className="alert alert-danger mar2" role="alert">
                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                      </div>
                    )}
                    <div className="card-body pdg">
                      <div className="table-responsive">
                        <div className="card-body custom-input">

                          <div className="row">
                            <div className="col">

                              <div className="mb-3 row">
                                <label className="col-sm-7">Faculty Name <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={isdisiplin} required>
                                    <option value={0} >Select Faculty</option>

                                    {faculty.map(facultys => (

                                      <option value={facultys.id}  >{facultys.faculty_name}</option>
                                    ))}

                                  </select>
                                  {errors.cfaculty && <p className="text-danger">{errors.cfaculty}</p>}
                                </div>

                              </div>
                              <div className="mb-3 row">

                                <label className="col-sm-7">Discipline <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="discipline_id" name="discipline_id" onChange={ischange} required>
                                    <option value={0}>Select Discipline</option>
                                    {discipline.map(disciplines => (
                                      disciplines.faculty_name === facultyname && (
                                        <option key={disciplines.id} value={disciplines.id}>{disciplines.discipline_name}</option>
                                      )
                                    ))}
                                  </select>
                                  {errors.cdiscipline && <p className="text-danger">{errors.cdiscipline}</p>}
                                </div>
                              </div>
                              <div className="mb-3 row">

                                <label className="col-sm-7">Semester <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="semester_id" name="semester_id" onChange={ischange} required>
                                    <option value={0}>Select Semester</option>


                                    <option key={1} value={1}> Semester-1</option>
                                    <option key={2} value={2}> Semester-2</option>

                                  </select>
                                  {errors.csemester && <p className="text-danger">{errors.csemester}</p>}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-sm-7">Select Course Component Type <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="coursecomponentstype" name="coursecomponentstype" onChange={ischange} required>
                                    <option value="">---Select---</option>


                                    <option value={1}>Ability Enhancement Courses - AEC1 English</option>
                                    <option value={12}>Ability Enhancement Courses - AEC2 Other Languages</option>

                                  </select>
                                  {errors.ccomponenttype && <p className="text-danger">{errors.ccomponenttype}</p>}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-sm-7">Course</label>
                                <div className="col-sm-5">
                                  <Select
                                    className="form-control"
                                    id="coursecomponent"
                                    name="coursecomponent"
                                    options={course_component.map(coursecomponents => ({
                                      value: coursecomponents.id,
                                      label: coursecomponents.course_name
                                    }))}
                                    onChange={handleCourseComponentChange}
                                    required
                                  />
                                  {errors.ccourse && <p className="text-danger">{errors.ccourse}</p>}
                                </div>

                              </div>

                              <div className="mb-3 row">
                                <label className="col-sm-7">Remarks</label>
                                <div className="col-sm-5">
                                  <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" />
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 txt-aln">
                          <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                          <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
